import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export const MetricCard = ({ title, value, subtitle, icon: Icon, trend, className }) => {
  return (
    <Card className={cn('bg-white border border-slate-100 shadow-[0_2px_8px_rgba(0,0,0,0.04)]', className)}>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-slate-500">{title}</CardTitle>
        {Icon && (
          <div className="p-2 rounded-lg bg-[#FFF0F1]">
            <Icon className="h-4 w-4 text-[#FF5A6E]" />
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold text-slate-900 font-[Manrope]">{value}</div>
        {subtitle && (
          <p className="text-xs text-slate-500 mt-1">{subtitle}</p>
        )}
        {trend !== undefined && (
          <p className={cn(
            'text-xs mt-1 font-medium',
            trend >= 0 ? 'text-emerald-600' : 'text-rose-600'
          )}>
            {trend >= 0 ? '+' : ''}{trend}% vs hier
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard;
